<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="lead text-white">
          Select Date
        </p>
        <div class="countryselect-wrapper">
          <date-picker
            v-model="value"
            type="date"
            leng="en"
            range
            placeholder="Select date range"
          ></date-picker>
          <p>Value: '{{ value }}'</p>
        </div>
        <p class="lead text-white">
          Select Hotel Category.
        </p>
        <div class="countryselect-wrapper">
          <multiselect
            :multiple="true"
            placeholder="Select Hotel Category"
            v-model="form.hotelcatgory"
            :options="options"
          ></multiselect>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <p class="lead text white">
          No. of Person
        </p>
        <input
          name="noofperson"
          class="countryselect-wrapper"
          placeholder="No. of Person"
          v-model="noofperson"
        />

        <p class="lead text white">
          Add cruise
        </p>
        <input name="addcruise" placeholder="Add Cruise" v-model="addcruise" />
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "Traveldatefromto",
  components: {
    DatePicker,
  },
  data() {
    return {
      value: "",
      range: "",
      noofperson: "",
      options: ["7 star", "5 star", "4 star", "3 star", "2 star"],
      addcruise: "",
      form: {
        hotelcatgory: null,
      },
    };
  },
};
</script>

<style scoped></style>
